// extracted by mini-css-extract-plugin
export var buttonLink = "portableText-module--buttonLink--14a02";
export var horizontalLine = "portableText-module--horizontalLine--6f979";
export var link = "portableText-module--link--3a4fb";
export var quote = "portableText-module--quote--9d52a";
export var quoteContainer = "portableText-module--quoteContainer--20170";
export var sidebar = "portableText-module--sidebar--3cc13";
export var text = "portableText-module--text--52e6b";